import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { WidgetProps } from '@/lib/widgets/types';
import { MapPin, Navigation, Eye, Maximize2 } from 'lucide-react';

export function FleetMapWidget({ isEditing = false }: WidgetProps) {
  const vehicles = [
    { id: 'ABC-1234', status: 'moving', location: 'Av. Paulista, SP', speed: 45 },
    { id: 'DEF-5678', status: 'stopped', location: 'Centro, RJ', speed: 0 },
    { id: 'GHI-9012', status: 'moving', location: 'Bela Vista, SP', speed: 32 },
    { id: 'JKL-3456', status: 'offline', location: 'Última posição', speed: 0 }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'moving': return 'bg-green-100 text-green-700';
      case 'stopped': return 'bg-yellow-100 text-yellow-700';
      case 'offline': return 'bg-red-100 text-red-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'moving': return 'Em Movimento';
      case 'stopped': return 'Parado';
      case 'offline': return 'Offline';
      default: return status;
    }
  };

  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium flex items-center gap-2">
            <MapPin className="h-4 w-4" />
            Mapa da Frota
          </CardTitle>
          <Button variant="ghost" size="sm" className="h-6 w-6 p-0" disabled={isEditing}>
            <Maximize2 className="h-3 w-3" />
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {/* Mock map area */}
          <div className="bg-muted rounded-lg p-4 h-32 flex items-center justify-center border-2 border-dashed">
            <div className="text-center text-muted-foreground">
              <MapPin className="h-8 w-8 mx-auto mb-2" />
              <p className="text-sm">Mapa da Frota</p>
              <p className="text-xs">Vista em tempo real</p>
            </div>
          </div>

          {/* Vehicle list */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-muted-foreground">VEÍCULOS ONLINE</span>
              <Badge variant="outline" className="text-xs">
                {vehicles.filter(v => v.status !== 'offline').length}/{vehicles.length}
              </Badge>
            </div>
            
            {vehicles.slice(0, 3).map((vehicle) => (
              <div key={vehicle.id} className="flex items-center justify-between p-2 rounded-lg bg-muted/50">
                <div className="flex items-center gap-2">
                  <Navigation className="h-3 w-3 text-muted-foreground" />
                  <div>
                    <p className="text-xs font-medium">{vehicle.id}</p>
                    <p className="text-xs text-muted-foreground">{vehicle.location}</p>
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <Badge className={`text-xs ${getStatusColor(vehicle.status)}`}>
                    {getStatusLabel(vehicle.status)}
                  </Badge>
                  <Button variant="ghost" size="sm" className="h-5 w-5 p-0" disabled={isEditing}>
                    <Eye className="h-3 w-3" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}